import { gql } from 'graphql-request'

export const BAN_TOP_CHART_BOOK = gql`
  mutation BanTopChartBooks($banTopChartInput: BanTopChartBooksInput!) {
    banTopChartBooks(banTopChartInput: $banTopChartInput) {
      message
    }
  }
`
